import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

const CookiePolicy: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h3" gutterBottom fontWeight="bold" color="primary">Cookie Policy</Typography>
                <Typography variant="body1" paragraph>
                    We use cookies to enhance your experience.
                </Typography>

                <Typography variant="h6" gutterBottom>What are cookies?</Typography>
                <Typography variant="body1" paragraph>
                    Cookies are small text files stored on your device that help us remember your preferences and login state.
                </Typography>

                <Typography variant="h6" gutterBottom>How we use them</Typography>
                <Typography variant="body1" paragraph>
                    - <strong>Essential Cookies:</strong> Required for login and navigation.<br />
                    - <strong>Analytics Cookies:</strong> Help us understand how the site is used.
                </Typography>
            </Paper>
        </Container>
    );
};
export default CookiePolicy;
